import type { ListenerType } from "../store/onboardingStore";

// Hours listened per month by listener type (from quiz 1)
const HOURS_PER_MONTH: Record<ListenerType, number> = {
  casual: 30,
  "music-lover": 60,
  superfan: 90,
};

const AVG_SONG_LENGTH_SEC = 180; // 3 min average song
const PAY_PER_STREAM = 0.002; // £0.002 per stream (Spotify-like)
const SUBSCRIPTION = 13; // £13/mo
const OPTIMAL_STREAMS = SUBSCRIPTION / PAY_PER_STREAM; // 6,500 streams/mo

export function computeAha2Values(
  listenerType: ListenerType,
  yearsStreaming: number,
): { yearlyAmount: string; totalLost: string } {
  const hours = HOURS_PER_MONTH[listenerType];
  const streamsPerMonth = (hours * 3600) / AVG_SONG_LENGTH_SEC;
  const monthlyLoss = (OPTIMAL_STREAMS - streamsPerMonth) * PAY_PER_STREAM;
  const yearly = Math.round(monthlyLoss * 12);
  const total = yearly * Math.max(yearsStreaming, 1);
  return {
    yearlyAmount: `£${yearly}`,
    totalLost: `£${total}`,
  };
}
